import axios from 'axios';
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const util = require('../utils/index');

const process = require('../env');
const getCredentials = () => {
  const userLogged = util.getUser();

  const credentials = {
    username: userLogged.login,
    password: userLogged.senha
  }

  return credentials;
}


export const registrarEscolaApi = async (formValue) => {
  try{
  
      const response = await axios.post(`${process.env.URL}/brand/createBrand`, formValue, {
        auth: getCredentials()
      })
  
      if (response.status === 200){
        return true;
      }

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}


export const listarEscolaApi = async () => {
  try{
      const response = await axios.get(`${process.env.URL}/brand/getBrands`, {
        auth: getCredentials()
      })
      const users = response.data
      if (response.status === 200){
        return users;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const pegarEscolaApi = async (id) => {
  try{
      const response = await axios.post(`${process.env.URL}/brand/getBrandByID`, id, {
        auth: getCredentials()
      })
      const user = response.data
      if (response.status === 200){
        return user;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const atualizarEscolaApi = async (formValue) => {
  try{
      const response = await axios.put(`${process.env.URL}/brand/updateBrand`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);
    }
  return false;
}

export const excluirEscolaApi = async (formValue) => {
  try{
      const response = await axios.post(`${process.env.URL}/brand/deleteBrand`, formValue, {
        auth: getCredentials()
      })
      if (response.status === 200){
        return true;
      }
      

    }catch(e){
     toast.error(e.response.data['message']);

    }
  return false;
}